import { Skeleton } from '~/@/components/ui/skeleton'

/**
 * Skeleton for the loading state of workspace name in the main workspace title bar
 * that is right underneath the navigation bar.
 */
export function TitleBarSkeleton() {
  return (
    <div className="flex h-8 items-center space-x-2">
      <Skeleton className="h-8 w-[200px] bg-gray-1" />
    </div>
  )
}
